import React from 'react';
// css file
import './features.css';
// components file
import Header from '../components/Home/Header';
import SupportScreen from '../components/support/SupportScreen';

const Support = () => {
  return (
    <div>
        <Header/>
        <SupportScreen/>
    </div>
  )
}

export default Support;
